import { makeAutoObservable, reaction } from 'mobx';
import { ServerError } from '../models/serverError';

class CommonStore {
  token: string | null = localStorage.getItem('jwt');
  appLoaded = false;
  error: ServerError | null = null;

  constructor() {
    makeAutoObservable(this);
    //  this reaction will run only when the token changes
    reaction(
      () => this.token,
      (token) => {
        if (token) {
          localStorage.setItem('jwt', token);
        } else {
          localStorage.removeItem('jwt');
        }
      },
    );
  }

  setServerError(error: ServerError) {
    this.error = error;
  }

  setToken = (token: string | null) => {
    this.token = token;
  };

  setAppLoaded = () => {
    this.appLoaded = true;
  };
}

export { CommonStore };
